export default __webpack_public_path__ + "static/iconography-image-b-53e862c0629b27840befc2e30b2a9936523297a9f5bf4747f418156c4be4e1db.png";